import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'

function toCalendarGridResponse({
  dayLoads = EMPTY_OBJECT,
  items = EMPTY_LIST,
  settingsHint = EMPTY_OBJECT,
}) {
  return { dayLoads, items, settingsHint }
}

export function getCalendarGridResponse(response) {
  return toCalendarGridResponse(
    Array.isArray(response) ? { items: response } : response
  )
}

export function getCalendarGridRangeKey({ from, to }) {
  return JSON.stringify({ from, to })
}

export function getCalendarGridReadKey({
  rangeKey,
  reloadKey,
  requestKey,
  timezone,
}) {
  return JSON.stringify({ rangeKey, reloadKey, requestKey, timezone })
}
